import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { DxFileUploaderComponent } from 'devextreme-angular';
import { FormHelperService } from '../../../services/form-helper.service';
import { FileService } from '../../../services/file-service';
import { DxFileUploaderModule } from 'devextreme-angular';
import { DocumentTypes } from '../register-merchant-form-container/ref-data';
import { KeycloakService } from 'keycloak-angular';
import { EnvironmentService } from '../../../services/environment.service';
import { RichFormComponent } from '../../../components/library/rich-form/rich-form.component';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrl: './documents.component.scss'
})
export class DocumentsComponent {

  @Input() formGroupName!: string;
  documentTypes!: DocumentTypes;
  usrKeyCloakId!: string;
  @Input() merchantId: number = 0;
  documentForm!: FormGroup;
  
  //#region /*FileManagementVariables*/

  FileUploadUrl! : string;
  iscopyOfRsaIdDropZoneActive = false;
  copyOfRsaIdimageSource = '';
  copyOfRsaIdtextVisible = true;
  copyOfRsaIdprogressVisible = false;
  copyOfRsaIdprogressValue = 0;

  isphysicalAddressDropZoneActive = false;
  physicalAddressimageSource = '';
  physicalAddresstextVisible = true;
  physicalAddressprogressVisible = false;
  physicalAddressprogressValue = 0;

  isindividualBankConfirmationLetterDropZoneActive = false;
  individualBankConfirmationLetterimageSource = '';
  individualBankConfirmationLettertextVisible = true;
  individualBankConfirmationLetterprogressVisible = false;
  individualBankConfirmationLetterprogressValue = 0;
  
  iscompanyRegistrationDropZoneActive = false;
  companyRegistrationimageSource = '';
  companyRegistrationtextVisible = true;
  companyRegistrationprogressVisible = false;
  companyRegistrationprogressValue = 0;

  isvatClearancefileDropZoneActive = false;
  vatClearancefileimageSource = '';
  vatClearancefiletextVisible = true;
  vatClearancefileprogressVisible = false;
  vatClearancefileprogressValue = 0;
  
  iscompanyPhysicalAddressDropZoneActive = false;
  companyPhysicalAddressimageSource = '';
  companyPhysicalAddresstextVisible = true;
  companyPhysicalAddressprogressVisible = false;
  companyPhysicalAddressprogressValue = 0;

  iscompanybankConfirmationLetterDropZoneActive = false;
  companybankConfirmationLetterimageSource = '';
  companybankConfirmationLettertextVisible = true;
  companybankConfirmationLetterprogressVisible = false;
  companybankConfirmationLetterprogressValue = 0;
  //#endregion

  //#region  Declare Individual File Uploader Variables
  @ViewChild("copyOfRsaId_fileUploader", { static: false })
  copyOfRsaIdfileUploader!: DxFileUploaderComponent;
  @ViewChild("copyOfRsaId_dropzone_external", { static: false })
  copyOfRsaIdDropZoneElement!: ElementRef;
  copyOfRsaId_checkBoxValue: boolean  = false;

  @ViewChild("physicalAddress_fileUploader", { static: false })
  physicalAddressfileUploader!: DxFileUploaderComponent;
  @ViewChild("physicalAddress_dropzone_external", { static: false })
  physicalAddressDropZoneElement!: ElementRef;
  physicalAddress_checkBoxValue: boolean  = false;

  @ViewChild("individualBankConfirmationLetter_fileUploader", { static: false })
  individualBankConfirmationLetter_fileUploader!: DxFileUploaderComponent;
  @ViewChild("individualBankConfirmationLetter_dropzone_external", { static: false })
  individualBankConfirmationLetterDropZoneElement!: ElementRef;
  individualBankConfirmationLetter_checkBoxValue: boolean  = false;
  //#endregion

  //#region  Declare Company Documents File Uploader Variables
  @ViewChild("companyRegistration_fileUploader", { static: false })
  companyRegistration_fileUploader!: DxFileUploaderComponent;
  @ViewChild("companyRegistration_dropzone_external", { static: false })
  companyRegistration_DropZoneElement!: ElementRef;
  companyRegistration_checkBoxValue: boolean  = false;

  @ViewChild("vatClearance_fileUploader", { static: false })
  vatClearancefile_Uploader!: DxFileUploaderComponent;
  @ViewChild("vatClearance_dropzone_external", { static: false })
  vatClearance_DropZoneElement!: ElementRef;
  vatClearance_checkBoxValue: boolean  = false;


  @ViewChild("companyPhysicalAddress_fileUploader", { static: false })
  companyPhysicalAddress_fileUploader!: DxFileUploaderComponent;
  @ViewChild("companyPhysicalAddress_dropzone_external", { static: false })
  companyPhysicalAddress_DropZoneElement!: ElementRef;
  companyPhysicalAddress_checkBoxValue: boolean  = false;

  @ViewChild("companybankConfirmationLetter_fileUploader", { static: false })
  companybankConfirmationLetter_fileUploader!: DxFileUploaderComponent;
  @ViewChild("companybankConfirmationLetter_dropzone_external", { static: false })
  companybankConfirmationLetter_DropZoneElement!: ElementRef;
  companybankConfirmationLetter_checkBoxValue: boolean = false;
  @ViewChild('documentFormComponent') documentFormComponent!: RichFormComponent;
  //#endregion
  
  
  constructor(private formGroupDirective: FormGroupDirective,
    private _formHelper: FormHelperService,
    private _fileService : FileService,
    private _keycloakService : KeycloakService, 
    private environmentService: EnvironmentService) 
  {
      this.onDropZoneEnter = this.onDropZoneEnter.bind(this);
      this.onDropZoneLeave = this.onDropZoneLeave.bind(this);
      this.onUploaded = this.onUploaded.bind(this);
      this.onProgress = this.onProgress.bind(this);
      this.onUploadStarted = this.onUploadStarted.bind(this);
      this._keycloakService
          .loadUserProfile()
          .then(e => {
            this.usrKeyCloakId = e.id!;
          });

      this.documentTypes = new DocumentTypes();
  }
  
  ngOnInit() : void 
  {
    this.documentForm = this.formGroupDirective.control.get(this.formGroupName) as FormGroup;
    this.FileUploadUrl = this.environmentService.getConfig('BackendApi') + 'api/Files/upload';
  }  


  ngAfterViewInit() {
    this.setFileUploaderOptions();
  }

  onDropZoneEnter(e) {
    var activeUploadArea =  e.dropZoneElement.id as string;
    switch (activeUploadArea) {
      case "copyOfRsaId-UploadArea":
        // code
        this.iscopyOfRsaIdDropZoneActive = true;
        break;
      case "physicalAddress-UploadArea":
        // code
        this.isphysicalAddressDropZoneActive = true;
        break;
      case "individualBankConfirmation-UploadArea":
          // code
        this.isindividualBankConfirmationLetterDropZoneActive = true;
       
        break;
      case "companyRegistration-UploadArea":
          // code
        this.iscompanyRegistrationDropZoneActive = true;
        break;
      case "vatClearance-UploadArea":
        // code
        this.isvatClearancefileDropZoneActive = true;
        break;
      case "companyPhysicalAddress-UploadArea":
          // code
        this.iscompanyPhysicalAddressDropZoneActive = true;
        break;
      case "companybankConfirmationLetter-UploadArea":
          // code
        this.iscompanybankConfirmationLetterDropZoneActive = true; 
       
        break;
    }
  }

  onDropZoneLeave(e)
  {  
    var activeUploadArea =  e.dropZoneElement.id as string;
    switch (activeUploadArea) {
      case "copyOfRsaId-UploadArea":
        // code
        this.iscopyOfRsaIdDropZoneActive = false;
       
        break;
      case "physicalAddress-UploadArea":
        // code
        this.isphysicalAddressDropZoneActive = false;
        
        break;
      case "individualBankConfirmation-UploadArea":
          // code
        this.isindividualBankConfirmationLetterDropZoneActive = false;
       
        break;
      case "companyRegistration-UploadArea":
          // code
        this.iscompanyRegistrationDropZoneActive = false;
        
        break;
      case "vatClearance-UploadArea":
        // code
        this.isvatClearancefileDropZoneActive = false;
      
        break;
      case "companyPhysicalAddress-UploadArea":
          // code
        this.iscompanyPhysicalAddressDropZoneActive = false; 
        
        break;
      case "companybankConfirmationLetter-UploadArea":
          // code
        this.iscompanybankConfirmationLetterDropZoneActive = false; 
      
        break;
    }
    
  }

  onUploaded(e) {
    var selectorFinishedUploading =  e.element.id as string;
    
    switch (selectorFinishedUploading) {
      case "copyOfRsaId-fileSelector":
        const copyOfRsaIdfile = e.file;
        const copyOfRsaIdfileReader = new FileReader();
        copyOfRsaIdfileReader.onload = () => {
          this.iscopyOfRsaIdDropZoneActive = false;
          this.copyOfRsaIdimageSource = copyOfRsaIdfileReader.result as string;
          this.copyOfRsaId_checkBoxValue = true;
          this.copyOfRsaIdprogressVisible = false;
          this.copyOfRsaIdprogressValue = 0;

          console.log("Is Finished and ready for upload",this.copyOfRsaIdimageSource.split(','));
          // this._fileService.UploadFile(e.file);
          
        };
        copyOfRsaIdfileReader.readAsDataURL(copyOfRsaIdfile);
        this.copyOfRsaIdtextVisible = false;
        break;
      case "physicalAddress-fileSelector":
        // code
        const physicalAddressfile = e.file;
        const physicalAddressfileReader = new FileReader();
        physicalAddressfileReader.onload = () => {
          this.isphysicalAddressDropZoneActive = false;
          this.physicalAddressimageSource = physicalAddressfileReader.result as string;
          this.physicalAddress_checkBoxValue = true;
          this.physicalAddressprogressVisible = false;
          this.physicalAddressprogressValue = 0;
        };
        physicalAddressfileReader.readAsDataURL(physicalAddressfile);
        this.physicalAddresstextVisible = false;
        break;
      case "individualBankConfirmation-fileSelector":
          // code
          const individualBankConfirmationfile = e.file;
          const individualBankConfirmationfileReader = new FileReader();
          individualBankConfirmationfileReader.onload = () => {
            this.isindividualBankConfirmationLetterDropZoneActive = false;
            this.individualBankConfirmationLetterimageSource = individualBankConfirmationfileReader.result as string;
            this.individualBankConfirmationLetter_checkBoxValue = true;
            this.individualBankConfirmationLetterprogressVisible = false;
            this.individualBankConfirmationLetterprogressValue = 0;
          };
          individualBankConfirmationfileReader.readAsDataURL(individualBankConfirmationfile);
          this.individualBankConfirmationLettertextVisible = false;
        break;
      case "companyRegistration-fileSelector":
          // code
        const companyRegistrationfile = e.file;
        const companyRegistrationfileReader = new FileReader();
        companyRegistrationfileReader.onload = () => {
          this.iscompanyRegistrationDropZoneActive = false;
          this.companyRegistrationimageSource = companyRegistrationfileReader.result as string;
          this.companyRegistration_checkBoxValue = true;
          this.companyRegistrationprogressVisible = false;
          this.companyRegistrationprogressValue = 0;
        };
        companyRegistrationfileReader.readAsDataURL(companyRegistrationfile);
        this.companyRegistrationtextVisible = false;
        break;
      case "vatClearance-fileSelector":
        // code
        const vatClearancefile = e.file;
        const vatClearancefilefileReader = new FileReader();
        vatClearancefilefileReader.onload = () => {
          this.isvatClearancefileDropZoneActive = false;
          this.vatClearancefileimageSource = vatClearancefilefileReader.result as string;
          this.vatClearance_checkBoxValue = true;
          this.vatClearancefileprogressVisible = false;
          this.vatClearancefileprogressValue = 0;
        };
        vatClearancefilefileReader.readAsDataURL(vatClearancefile);
        this.vatClearancefiletextVisible = false;
        break;
      case "companyPhysicalAddress-fileSelector":
          // code
          const companyPhysicalAddressfile = e.file;
          const companyPhysicalAddressfileReader = new FileReader();
          companyPhysicalAddressfileReader.onload = () => {
            this.iscompanyPhysicalAddressDropZoneActive = false;
            this.companyPhysicalAddressimageSource = companyPhysicalAddressfileReader.result as string;
            this.companyPhysicalAddress_checkBoxValue = true;
            this.companyPhysicalAddressprogressVisible = false;
            this.companyPhysicalAddressprogressValue = 0;
          };
          companyPhysicalAddressfileReader.readAsDataURL(companyPhysicalAddressfile);
          this.companyPhysicalAddresstextVisible = false;
        break;
      case "companybankConfirmationLetter-fileSelector":
        const companybankConfirmationLetterfile = e.file;
        const companybankConfirmationLetterfileReader = new FileReader();
        companybankConfirmationLetterfileReader.onload = () => {
          this.iscompanybankConfirmationLetterDropZoneActive = false;
          this.companybankConfirmationLetterimageSource = companybankConfirmationLetterfileReader.result as string;
          this.companybankConfirmationLetter_checkBoxValue = true;
          this.companybankConfirmationLetterprogressVisible = false;
          this.companybankConfirmationLetterprogressValue = 0;
          
        };
        companybankConfirmationLetterfileReader.readAsDataURL(companybankConfirmationLetterfile);
        this.companybankConfirmationLettertextVisible = false;
          break;
    } 
  }

  onProgress(e) {
    var selectorFinishedUploading =  e.element.id as string;
    switch (selectorFinishedUploading)
    {
      case "copyOfRsaId-fileSelector":
        this.copyOfRsaIdprogressValue = e.bytesLoaded / e.bytesTotal * 100;
        break;
      case "physicalAddress-fileSelector":
        // code
        this.physicalAddressprogressValue = e.bytesLoaded / e.bytesTotal * 100;
        break;
      case "individualBankConfirmation-fileSelector":
          // code
        this.individualBankConfirmationLetterprogressValue = e.bytesLoaded / e.bytesTotal * 100;
        break;
      case "companyRegistration-fileSelector":
          // code
        this.companyRegistrationprogressValue = e.bytesLoaded / e.bytesTotal * 100;
        break;
      case "vatClearance-fileSelector":
        // code
        this.vatClearancefileprogressValue = e.bytesLoaded / e.bytesTotal * 100;
        break;
      case "companyPhysicalAddress-fileSelector":
        this.companyPhysicalAddressprogressValue = e.bytesLoaded / e.bytesTotal * 100;
        break;
      case "companybankConfirmationLetter-fileSelector":
        this.companybankConfirmationLetterprogressValue = e.bytesLoaded / e.bytesTotal * 100;
        break;
    }
  }

  onUploadStarted(e) {
    var selectorFinishedUploading =  e.element.id as string;
    console.log(e.file.customData);
    let file : DxFileUploaderComponent = e.file;
    file.uploadCustomData = {
      userId: '123456',
      timestamp: new Date().toISOString()
    }

    switch (selectorFinishedUploading)
    {
      case "copyOfRsaId-fileSelector":
        this.copyOfRsaIdimageSource = '';
        this.copyOfRsaIdprogressVisible = true;
        break;
      case "physicalAddress-fileSelector":
        // code
        this.physicalAddressimageSource = '';
        this.physicalAddressprogressVisible = true;
        break;
      case "individualBankConfirmation-fileSelector":
          // code
        this.individualBankConfirmationLetterimageSource = '';
        this.individualBankConfirmationLetterprogressVisible = true;
        break;
      case "companyRegistration-fileSelector":
          // code
          this.companyRegistrationimageSource = '';
          this.companyRegistrationprogressVisible = true;
        break;
      case "vatClearance-fileSelector":
        // code
        this.vatClearancefileimageSource = '';
        this.vatClearancefileprogressVisible = true;
        break;
      case "companyPhysicalAddress-fileSelector":
        this.companyPhysicalAddressimageSource = '';
        this.companyPhysicalAddressprogressVisible = true;
        break;
      case "companybankConfirmationLetter-fileSelector":
        this.companybankConfirmationLetterimageSource = '';
        this.companybankConfirmationLetterprogressVisible = true;
        break;
    }
  }

  setFileUploaderOptions()
  {

    var allowedFileExtensionsList = ['.jpg', '.jpeg', '.gif', '.png','.pdf']

    this.copyOfRsaIdfileUploader.instance.option({
      dropZone: this.copyOfRsaIdDropZoneElement.nativeElement,
      dialogTrigger: this.copyOfRsaIdDropZoneElement.nativeElement,
      allowedFileExtensions: allowedFileExtensionsList
    });

    this.physicalAddressfileUploader.instance.option({
      dropZone: this.physicalAddressDropZoneElement.nativeElement,
      dialogTrigger: this.physicalAddressDropZoneElement.nativeElement,
      allowedFileExtensions: allowedFileExtensionsList
    });

    this.individualBankConfirmationLetter_fileUploader.instance.option({
      dropZone: this.individualBankConfirmationLetterDropZoneElement.nativeElement,
      dialogTrigger: this.individualBankConfirmationLetterDropZoneElement.nativeElement,
      allowedFileExtensions: allowedFileExtensionsList
    });

    this.companyRegistration_fileUploader.instance.option({
      dropZone: this.companyRegistration_DropZoneElement.nativeElement,
      dialogTrigger: this.companyRegistration_DropZoneElement.nativeElement,
      allowedFileExtensions: allowedFileExtensionsList
    });

    this.vatClearancefile_Uploader.instance.option({
      dropZone: this.vatClearance_DropZoneElement.nativeElement,
      dialogTrigger: this.vatClearance_DropZoneElement.nativeElement,
      allowedFileExtensions: allowedFileExtensionsList
    });

    this.companyPhysicalAddress_fileUploader.instance.option({
      dropZone: this.companyPhysicalAddress_DropZoneElement.nativeElement,
      dialogTrigger: this.companyPhysicalAddress_DropZoneElement.nativeElement,
      allowedFileExtensions: allowedFileExtensionsList
    });

    this.companyPhysicalAddress_fileUploader.instance.option({
      dropZone: this.companyPhysicalAddress_DropZoneElement.nativeElement,
      dialogTrigger: this.companyPhysicalAddress_DropZoneElement.nativeElement,
      allowedFileExtensions: allowedFileExtensionsList
    });

    this.companybankConfirmationLetter_fileUploader.instance.option({
      dropZone: this.companybankConfirmationLetter_DropZoneElement.nativeElement,
      dialogTrigger: this.companybankConfirmationLetter_DropZoneElement.nativeElement,
      allowedFileExtensions: allowedFileExtensionsList
    });

  }

  statusFormat(value) {
    return (value * 100).toFixed(2) + " %" ;
  }

  cancel() {
      this.documentFormComponent.clearForm();
  }
}
